export const body = {
    paddingLeft: "30px",
    paddingRight: "30px"
};

export const heading = {
    textAlign: "center"
};

export const buttonsContainer = {
    display: "flex",
    flex: "1",
    flexDirection: "row",
    visibility: "hidden"
};
